import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { tenantPortalAPI } from '../lib/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { toast } from 'sonner';
import { KeyRound, Loader2, AlertCircle } from 'lucide-react';

export default function MieterPasswortReset() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 6) {
      toast.error('Passwort muss mindestens 6 Zeichen lang sein.');
      return;
    }
    if (password !== confirm) {
      toast.error('Die Passwörter stimmen nicht überein.');
      return;
    }
    setLoading(true);
    try {
      await tenantPortalAPI.resetPassword({ token, new_password: password });
      toast.success('Passwort erfolgreich aktualisiert. Bitte einloggen.');
      navigate('/mieter/login');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Reset fehlgeschlagen.');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
        <Card className="w-full max-w-md border-slate-200 shadow-lg">
          <CardHeader className="text-center">
            <div className="flex justify-center mb-4">
              <div className="w-14 h-14 bg-red-100 rounded-xl flex items-center justify-center">
                <AlertCircle className="w-8 h-8 text-red-600" />
              </div>
            </div>
            <CardTitle>Ungültiger Link</CardTitle>
            <CardDescription>Der Reset-Link ist unvollständig oder fehlerhaft.</CardDescription>
          </CardHeader>
          <CardContent>
            <Link to="/mieter/passwort-vergessen">
              <Button className="w-full bg-slate-900 hover:bg-slate-800">Neuen Link anfordern</Button>
            </Link>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-md border-slate-200 shadow-lg" data-testid="reset-password-card">
        <CardHeader className="text-center pb-2">
          <div className="flex justify-center mb-4">
            <div className="w-14 h-14 bg-emerald-100 rounded-xl flex items-center justify-center">
              <KeyRound className="w-8 h-8 text-emerald-600" />
            </div>
          </div>
          <CardTitle className="text-2xl" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Neues Passwort festlegen
          </CardTitle>
          <CardDescription>
            Wählen Sie ein neues Passwort für Ihr Mieterportal-Konto.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="password">Neues Passwort</Label>
              <Input
                id="password"
                type="password"
                data-testid="reset-password-input"
                placeholder="Mindestens 6 Zeichen"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                minLength={6}
                required
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="confirm">Passwort bestätigen</Label>
              <Input
                id="confirm"
                type="password"
                data-testid="reset-confirm-input"
                placeholder="Passwort wiederholen"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                minLength={6}
                required
              />
            </div>
            <Button
              type="submit"
              className="w-full bg-slate-900 hover:bg-slate-800"
              data-testid="reset-submit-button"
              disabled={loading}
            >
              {loading ? (
                <>
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                  Speichern...
                </>
              ) : (
                'Passwort speichern'
              )}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
